
import { IDialogProps } from "@digitallab/grid-common-frontend-components";
import { createContext } from "react";
export const DialogServiceContext = createContext<{
  show: ((props: IDialogProps) => Promise<unknown>) | (() => void);
}>({ show: () => {} });